import { render, staticRenderFns } from "./receiveSuccess.vue?vue&type=template&id=d1725352&scoped=true&"
import script from "./receiveSuccess.vue?vue&type=script&lang=js&"
export * from "./receiveSuccess.vue?vue&type=script&lang=js&"
import style0 from "./receiveSuccess.vue?vue&type=style&index=0&id=d1725352&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1725352",
  null
  
)

export default component.exports